import Core from "@/modules/core/service/Core";
import Common from "@/modules/dis/service/order/private/Common";

const url = {
    dissolve   : "/api/disposition/order/{0}/unit/{1}",
    dissolveAll: "/api/disposition/order/{0}/unit?zip={1}&city={2}&street={3}&contact={4}",
}

const removeAssignments = function (assignmentsToRemove, assignments) {
    assignmentsToRemove.forEach (assignmentToRemove => {
        const index = assignments.findIndex(assignment => assignment.id === assignmentToRemove.id);
        if (index >= 0) {
            assignments.splice(index, 1);
        }
    });
};

const dissolve = function (order, unit) {
    return Core.method.delete(url.dissolve, null, order.id, unit.id);
}

const dissolveAll = function (order, location) {
    return Core.method.delete(
        url.dissolveAll,
        null,
        order.id,
        location.zip,
        location.city,
        location.street,
        location.contact
    );
}

export default {
    /**
     * Removes the given unit from the given order.
     *
     * @param component the calling VUE component
     * @param order the order from which the unit is to be removed
     * @param location the units location
     * @param unit The unit to be removed from the order
     * @param assignments the list of inspections currently assigned to the order
     */
    unit (component, order, location, unit, assignments) {
        const query = component.$t("disposition.inspection.remove.query");
        const text  = component.$t("disposition.inspection.remove.text");

        Core.message.confirm(component, query, text, Core.message.Default, (confirmed) => {
            if (confirmed) {
                dissolve(order, unit).then(assignment => {
                    removeAssignments([ assignment], assignments);

                    Common.publishAssignments(
                        component,
                        order,
                        location,
                        Common.NULL_ASSIGNMENT,
                        assignments
                    );

                    Core.message.hint(component, component.$t("disposition.inspection.remove.done"));
                });
            }
        });
    },

    /**
     * Removes all units belonging to the specified location from the given order.
     *
     * @param component the calling VUE component
     * @param location the location (zip, city and street)
     * @param order
     * @param assignments the list of inspections currently assigned to the order
     */
    location (component, location, order, assignments) {
        const query = component.$t("disposition.inspection.removeAll.query");
        const text  = component.$t("disposition.inspection.removeAll.text", [
            location.zip,
            location.city,
            location.street,
            location.contact,
            order.no
        ]);

        Core.message.confirm(component, query, text, Core.message.Default, (confirmed) => {
            if (!confirmed) {
                return;
            }

            Core.loading(component, true)
            dissolveAll(order, location).then(inspections => {
                removeAssignments(inspections, assignments);

                Common.publishAssignments(
                    component,
                    order,
                    location,
                    Common.NULL_ASSIGNMENT,
                    assignments
                );

                Core.message.hint(component, component.$t("disposition.inspection.removeAll.success"));
                Core.loading(component, false);
            });
        });
    },
}